<template>
  <transition name="fade">
    <button
      v-if="isVisible"
      @click="scrollToTop"
      class="scroll-to-top-btn fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 w-12 h-12 md:w-14 md:h-14 bg-brand hover:bg-brand/90 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
      :class="{ 'scroll-to-top-cart-offset': isCartBarVisible }"
      aria-label="Наверх"
    >
      <PhCaretUp :size="20" :weight="'regular'" color="white" class="transition-transform duration-300 group-hover:-translate-y-0.5" />
    </button>
  </transition>
</template>

<script>
import { PhCaretUp } from '@phosphor-icons/vue'
import { useRoute } from 'vue-router'
import { useCart } from '@/store/useCart'

export default {
  name: 'ScrollToTop',
  components: {
    PhCaretUp
  },
  setup() {
    const route = useRoute()
    const cart = useCart()
    return { route, cart }
  },
  computed: {
    isCartBarVisible() {
      return this.route.path === '/cart' && this.cart.cartItems?.length > 0
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      // Show button when scrolled down 300px
      this.isVisible = window.scrollY > 300
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* На мобилке на странице корзины скрываем — мешает кнопке «Оформить» */
@media (max-width: 1023px) {
  .scroll-to-top-btn.scroll-to-top-cart-offset {
    display: none;
  }
}
</style>

